import React from 'react'
import { Panel, Row, Col, Icon } from 'rsuite'

export default function ViewFormListChoiceWidget({ schema, ...props }) {
  const emptyValue = <>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</>

  const displayCompt = (data, tabRight) => {
    console.log('data : ', data)
    return (
      <>
        {data?.map((item) => {
          let inputObj

          if (item.type && item.type != 'LABEL') {
            if (item.type == 'RADIO') {
              inputObj = (
                <>
                  <span>{item.label || ''}</span>
                  {item.inputOptions.map((e) => {
                    return (
                      <div style={{ marginLeft: 15, marginTop: 10 }}>
                        <Icon
                          icon={e.value == item.value ? 'check-square-o' : 'square-o'}
                          style={{ color: e.value == item.value ? '#2da888' : '' }}
                          size="lg"
                        />
                        <span style={{ marginLeft: 10 }}>{e.label}</span>
                        {e.value == item.value && (
                          <div style={{ marginLeft: 30, marginTop: 10 }}>
                            {e?.moreInputs?.map((se) => {
                              return (
                                <div style={{ marginTop: 10, overflowWrap: 'anywhere' }}>
                                  <>{`${se.label || ''} `}</>
                                  <>{se.value ? <b>{se.value} </b> : <u>{emptyValue}</u>}</>
                                  <>{se.postLabel || ''}</>
                                </div>
                              )
                            })}
                          </div>
                        )}
                      </div>
                    )
                  })}
                </>
              )
            }
          } else if (item.resultType) {
            inputObj = (
              <>
                <span>{item.label || ''}</span>
                <>{item.value ? <b>{item.value} </b> : <u>{emptyValue}</u>}</>
                {item.childs && displayCompt(item.childs, true)}
              </>
            )
          } else {
            inputObj = (
              <div style={{ marginTop: 10 }}>
                {item.label}
                {item.childs && displayCompt(item.childs, true)}
              </div>
            )
          }

          //console.log('inputObj : ', inputObj)
          return (
            <Row style={{ marginLeft: tabRight ? 20 : undefined, marginBottom: 10 }}>
              <Col xs={24} sm={24} md={24} lg={24}>
                {inputObj}
              </Col>
            </Row>
          )
        })}
      </>
    )
  }

  return (
    <Panel
      header={props.header}
      collapsible={props.collapsible}
      defaultExpanded={props.defaultExpanded}
      bordered={props.bordered}
      style={{ marginBottom: 20 }}
    >
      <div style={{ marginTop: -10 }}>{schema?.objects && displayCompt(schema.objects, false)}</div>
    </Panel>
  )
}
